import React from 'react';

import { useIntl } from 'react-intl-next';

import ErrorIcon from '@atlaskit/icon/core/migration/error';
import InfoIcon from '@atlaskit/icon/core/migration/information--info';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { P400, R300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const textStyles = xcss({
	color: 'color.text.subtlest',
	font: token('font.body'),
});

const DeletedWarning = () => {
	const intlApi = useIntl();

	return (
		<Flex alignItems="center" columnGap="space.100">
			<ErrorIcon
				spacing="spacious"
				// TODO: make icon labels common translations
				label="warning"
				color={token('color.icon.danger', R300)}
			/>
			<Box xcss={textStyles} as="span">
				{intlApi.formatMessage(messages.noOneIsOnCall)}
			</Box>
		</Flex>
	);
};

const ForwardedInfo = () => {
	const intlApi = useIntl();

	return (
		<Flex alignItems="center" columnGap="space.100">
			<InfoIcon spacing="spacious" label="info" color={token('color.icon.discovery', P400)} />
			<Box xcss={textStyles} as="span">
				{intlApi.formatMessage(messages.forwardingParticipant)}
			</Box>
		</Flex>
	);
};

export { ForwardedInfo, DeletedWarning };
